__webpack_require__.p = "/frontend-mentor-toggle-pricing-component/";